import React from "react";
import { AUTH_TOKEN } from "utils/constants";
import {
  Environment,
  Network,
  RecordSource,
  Store,
  fetchQuery as fQ,
} from "relay-runtime";
import { commitMutation, QueryRenderer as QR } from "react-relay";
import moment from "moment";
import Loader from "components/Loader";
import Config from "config";

function network(operation, variables) {
  const authToken = window.localStorage.getItem(AUTH_TOKEN);
  let headers = { "Content-Type": "application/json" };
  if (authToken) {
    headers["Authorization"] = "JWT " + authToken;
  }
  
  return fetch(`${Config.BASE_URL}/graphql`, {
    method: "POST",
    headers: headers,
    body: JSON.stringify({
      query: operation.text,
      variables,
    }),
  })
    .then((response) => {
      if (!response.ok) {
        // Return error response in GraphQL format
        return {
          errors: [
            {
              message: `GraphQL request failed: ${response.statusText}`,
            },
          ],
          data: null,
        };
      }
      return response.json();
    })
    .catch((error) => {
      // Handle network errors gracefully (connection refused, network errors, etc.)
      // Only log in development mode to reduce console noise
      if (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "development") {
        console.warn("GraphQL network error (server may be unavailable):", error.message);
      }
      // Return a valid GraphQL error response format
      return {
        errors: [
          {
            message: error.message || "Failed to connect to GraphQL server. Please check if the server is running.",
          },
        ],
        data: null,
      };
    });
}

const environment = new Environment({
  network: Network.create(network),
  store: new Store(new RecordSource()),
});

function mutateBase({ mutation, variables, onSuccess, onFailure }) {
  const onCompleted = (response, errors) => {
    if (errors && errors.length > 0) {
      var messages = [];
      errors.forEach((error) => {
        messages.push(error.message);
      });
      messages = messages.join("; ");
      if (onFailure) {
        return onFailure(messages);
      } else {
        return alert(messages);
      }
    }
    return onSuccess(response);
  };
  return commitMutation(environment, {
    mutation,
    variables,
    onCompleted,
  });
}

function mutate({ mutation, input, onSuccess, onFailure }) {
  const variables = { input };
  return mutateBase({ mutation, variables, onSuccess, onFailure });
}

function QueryRenderer(_props) {
  const onSuccess = _props.onSuccess;
  return (
    <QR
      environment={environment}
      render={({ error, props }) => {
        if (error) {
          return <div> {error.message} </div>;
        }
        if (props && Object.keys(props).length > 0) {
          return onSuccess(props);
        }
        if (_props.isTable) {
          return (
            <tr>
              <td>Loading...</td>
            </tr>
          );
        }
        if (_props.isSelect) {
          return <option>Loading...</option>;
        } else {
          return <Loader />;
        }
      }}
      {..._props}
    />
  );
}

function fetchQuery(query, variables = {}) {
  return fQ(environment, query, variables).catch((error) => {
    // If Relay throws an error (e.g., network error, no data), 
    // return a safe default response instead of throwing
    // Only log in development mode to reduce console noise
    if (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "development") {
      console.warn("Relay query error (server may be unavailable):", error.message || error);
    }
    // Return a response that won't break the app
    return { me: null };
  });
}

export { QueryRenderer, mutate, fetchQuery, environment, mutateBase };
